import React from 'react';
import ForgetPasswordForm from 'components/authentication/ForgetPasswordForm';
import bgImg from 'assets/img/generic/home3.jpg';
import AuthSplitLayout from 'layouts/AuthSplitLayout';

const ForgetPassword = () => {
  return (
    <AuthSplitLayout
      bgProps={{ image: bgImg, position: '50% 76%', overlay: true }}
    >
      <div className="text-center">
        <h4 className="mb-0">¿Has olvidado tu contraseña?</h4>
        <small>Pon tu email y te enviaremos un link de reseteo.</small>
        <ForgetPasswordForm layout="split" />
      </div>
    </AuthSplitLayout>
  );
};

export default ForgetPassword;
